import { Action, State, StateContext } from '@ngxs/store';
import { EarningKpis, EarningResponse, FilterEarningAction, FilterEarningSuccessAction } from './earnings.action';
import { Injectable } from '@angular/core';
import { PaymentsService } from '@smatchy/sdk';
import { catchError, of, tap } from 'rxjs';
import { FailAction } from '../payouts';
import type { TheBodyOfAPaidEventDetail } from '../../../events/domains/the-paid-event-the-wallet-shows';
export const filterEarningEventStateName = 'filterEarningEvent';
export interface EarningEventStateModel {
  paidEvent: EarningResponse;
  kpis: EarningKpis;
  paidEventDetail: TheBodyOfAPaidEventDetail | null;
  loading: boolean;
  error?: unknown;
  sportsSelected: string[];
  payoutStatuses: string[];
  /*
   * `| null` on the three: the defaults below clear them with null, like the
   * explore filter and the paid-event filter before it. Said rather than
   * converted, since this state is persisted and null survives a round trip
   * through localStorage where undefined does not.
   */
  dateFilter: string | null;
  fromDate?: string | null;
  toDate?: string | null;
  priceFrom?: number;
  priceTo?: number;
  pricingChanged?: boolean;
}
const defaults: EarningEventStateModel = {
  paidEvent: {
    data: [],
    total: 0,
    page: 0,
    limit: 0,
  },
  kpis: {
    escrow: 0,
    available: 0,
    transferred: 0,
  },
  loading: false,
  paidEventDetail: null,
  sportsSelected: [],
  payoutStatuses: [],
  dateFilter: null,
  fromDate: null,
  toDate: null,
  priceFrom: 0,
  priceTo: 10000,
  pricingChanged: false,
};
@State<EarningEventStateModel>({
  name: filterEarningEventStateName,
  defaults: defaults,
})
@Injectable()
export class FilterEarningEventState {
  constructor(private readonly _events: PaymentsService) {}
  @Action(FilterEarningAction)
  async filter(ctx: StateContext<EarningEventStateModel>, action: FilterEarningAction) {
    ctx.patchState({ loading: true, error: null });
    return this._events.getMyPaidEventsOrganizer(action.filter).pipe(
      tap((res) => {
        ctx.dispatch(new FilterEarningSuccessAction(res as EarningResponse));
      }),
      catchError((error) => {
        ctx.dispatch(new FailAction(error));
        return of(error);
      }),
    );
  }
  @Action(FilterEarningSuccessAction)
  filterSuccess(ctx: StateContext<EarningEventStateModel>, action: FilterEarningSuccessAction) {
    return ctx.patchState({
      paidEvent: action.response,
      loading: false,
      error: null,
    });
  }
}
